import { NgModule } from '@angular/core';
import { StartCasePipe } from './start-case.pipe';
import { UpperCasePipe } from './upper-case.pipe';
import { AddCommaPipe } from './add-comma.pipe';
import { SnakeCaseToTitlePipe } from './snake-case-to-title.pipe';
import { GenderPipe } from './gender.pipe';
import { DateTimezonePipe } from './date-timezone.pipe';

@NgModule({
  declarations: [AddCommaPipe, StartCasePipe, UpperCasePipe, SnakeCaseToTitlePipe, GenderPipe, DateTimezonePipe],
  exports: [AddCommaPipe, StartCasePipe, UpperCasePipe, SnakeCaseToTitlePipe, GenderPipe, DateTimezonePipe],
})

export class SharedPipesModule {

  constructor() {
    console.log(`shared pipes module`);
  }
}
